import { Injectable } from '@angular/core';
import { Subject } from 'rxjs';
import { JavaScriptInterface, EventName, NATIVE_STORE_KEY } from './JavaScriptInterface';

declare var app: JavaScriptInterface;

export enum DeviceStoreKey {
    DeviceType = 'deviceType',
    DeviceToken = 'deviceToken',
}

@Injectable({
    providedIn: 'root'
})
export class NativeService {

    private readonly native: JavaScriptInterface;
    // デバイス情報を取得できたら、転送する
    deviceInfoSubject: Subject<string> = new Subject<string>();
    // デバイス情報を取得するためのオブザーバブル
    device$ = this.deviceInfoSubject.asObservable();

    constructor() {
        const noop = new class implements JavaScriptInterface {
            // WebView外での実行時はno-opにフォールバック
            scanDevices(): void {}
            setItem(_key: string, _value: string): void {}
            getItem(_key: string): string | null { return null; }
            removeItem(_key: string): void {}
            clear(): void {}
        }();

        if (typeof app !== 'undefined' && app !== null) {
            this.native = app;
            console.log('[NativeService] Androidネイティブブリッジを使用');
        } else {
            this.native = noop;
            console.log('[NativeService] フォールバックモード（WebView外）');
        }
        (<any>window).processMessage = this.processMessage.bind(this);
    }

    /**
   * AndroiとiOSを区別する
   */
    isAndroid(): boolean {
        return this.getDeviceType() === 'Android';
    }

    /**
   * デバイスタイプを取得する
   */
    getDeviceType(): string {
        let platform = this.getData(DeviceStoreKey.DeviceType);
        return platform.length > 0 ? platform : 'Android';
    }

    /**
   * LocalStorage中にデバイス情報を保存する
   */
    setData(key: string, value: string): void {
        localStorage.setItem(key, value);
    }

    /**
     * LocalStorage中のデバイス情報を取得する
     */
    getData(key: string): string {
        return localStorage.getItem(key) || '';
    }

    /**
     * デバイスを探す
     */
    scanDevices(): void {
        this.native.scanDevices()
    }

    /**
     * Nativeから受け取った値を処理する
     * @param eventName イベン名
     * @param json文字列形式のデータ
     */
    processMessage(eventName: any, data: string): void {
        console.log(eventName, data);

        switch (eventName) {
            // デバイス情報
            case EventName.DeviceInfos:
                this.sendDeviceInfos(data);
                break;
        }
    }

    /**
   * デバイストークンを取得する
   */
    getDeviceToken(): string {
        let token = this.getData(DeviceStoreKey.DeviceToken);
        return token.length > 0 ? token : 'Device_Token_None';
    }

    /**
     *  デバイス情報を取得できたら、転送する
     *  @param data デバイス情報
     */
    sendDeviceInfos(data: string): void {
        this.deviceInfoSubject.next(data);
    }

    /**
     * SharedPreferencesに値を保存する
     * @param key キー
     * @param value 値
     */
    nativeSetItem(key: string, value: string): void {
        this.native.setItem(key, value);
    }

    /**
     * SharedPreferencesから値を取得する
     * @param key キー
     */
    nativeGetItem(key: string): string | null {
        return this.native.getItem(key);
    }

    /**
     * SharedPreferencesから値を削除する
     * @param key キー
     */
    nativeRemoveItem(key: string): void {
        this.native.removeItem(key);
    }

    /**
     * SharedPreferencesを全てクリアする
     */
    nativeClear(): void {
        this.native.clear();
    }

    /**
     * アクセストークンをAndroidのSharedPreferencesに同期する
     * @param token アクセストークン
     */
    syncToken(token: string): void {
        console.log('[NativeService] syncToken:', token ? `${token.substring(0, 10)}...` : 'empty');
        this.nativeSetItem(NATIVE_STORE_KEY.AccessToken, token);
    }

    /**
     * アクセストークンをAndroidのSharedPreferencesから削除する
     */
    clearToken(): void {
        this.nativeRemoveItem(NATIVE_STORE_KEY.AccessToken);
    }

}
